import {put, takeEvery, all} from 'redux-saga/effects';
import {showNotification} from 'admin-on-rest';

function* fuseNoServerAvailable() {
    console.log('fuseNoServerAvailable');
    yield put(showNotification('No Server Available.', 'warning'))
}
export default function* fuseSaga() {
    yield all([
        takeEvery('FUSE_NO_SERVER', fuseNoServerAvailable)
    ]);
}


// WEBPACK FOOTER //
// ./src/Fuse/admin/fuseSaga.js